/**
 * Check whether browser supports native date control
 * https://stackoverflow.com/a/10199306
 */
function checkDateInput() {
	const input = document.createElement('input');
	const notADateValue = 'not-a-date';

	input.setAttribute('type', 'date');
	input.setAttribute('value', notADateValue);

	return input.value !== notADateValue;
}

/**
 * Set `input["date"]` value to `YYYY-MM-DD` if browser supports native control
 * @param {Node} form
 */
function customizeDateInputs(form) {
	const supportsDateInput = checkDateInput();

	if (!supportsDateInput) {
		return;
	}

	const inputs = form.querySelectorAll('[type="date"]');

	inputs.forEach(input => {
		const date = input.getAttribute('data-form-date');
		const field = input.closest('[data-form="field"] ');
		const formatHintText = field ? field.querySelector('[data-form="formatHintText"]') : null;

		if (date) {
			input.value = date;
		}

		if (formatHintText) {
			formatHintText.parentNode.removeChild(formatHintText);
		}
	});
}

export { customizeDateInputs };
